<template>
  <v-card>
    <v-form @submit.prevent="submitAddTrip()" ref="addTripForm">
      <v-container>
        <v-layout row wrap>
          <dialog-header :title="'Add'" :details="`Trip (Docket: ${docket.id})`"></dialog-header>
          <flex-sub-header>
            <div class="flex-container-space-between">
              <div>{{docket.site.project.name}} - {{docket.site.name}}</div>
              <div>{{makeLongDate(docket.date)}}</div>
            </div>
          </flex-sub-header>

          <v-flex xs12 class>
            <div class="flex-container-space-between">
              <div>
                <div class="vertical-center-container">
                  <div
                    class="grey--text text--darken-1 body-2"
                  >{{`${docket.vehicle.name} (${docket.vehicle.vehicleType.name})`}} / {{ docket.driver.name}}</div>
                </div>
                <div class="grey--text">{{docket.vehicle.contractor.name}}</div>
              </div>
            </div>
          </v-flex>
          <card-divider-header></card-divider-header>

          <!-- TIP / SPOIL -->
          <!-- TIP / SPOIL -->
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Tip"
              :color="primaryNeutral"
              :items="filteredTips"
              v-model="trip.tipId"
              @change="trip.spoilId = null"
              item-text="name"
              item-value="id"
              :loading="loadingTips"
              :rules="tipRules"
              :prepend-icon="$store.state.global.pages.tip.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Spoil"
              :color="primaryNeutral"
              :items="filteredSpoils"
              v-model="trip.spoilId"
              item-text="name"
              item-value="id"
              :loading="loadingSpoils"
              :rules="spoilRules"
              :prepend-icon="$store.state.global.pages.spoil.icon"
              clearable
            ></v-autocomplete>
          </v-flex>

          <!-- HOURS -->
          <!-- HOURS -->
          <template v-if="showHours">
            <v-flex xs12>
              <div class="body-2 grey--text text--darken-1">Timesheet</div>
            </v-flex>
            <v-flex xs6 class="grey--text">
              <time-picker-wrapper v-model="trip.start" label="Start Time"></time-picker-wrapper>
            </v-flex>
            <v-flex xs6 class="grey--text">
              <time-picker-wrapper v-model="trip.end" label="End Time"></time-picker-wrapper>
            </v-flex>
            <v-flex xs6 class="grey--text">
              <v-text-field
                disabled
                v-model="billableHours"
                label="Billable Hours"
                type="number"
                prepend-icon="access_time"
                autofocus
                :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="grey--text">
              <v-text-field
                v-model="trip.breaks"
                label="Breaks"
                type="number"
                prepend-icon="alarm_off"
                :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="grey--text">
              <v-text-field
                v-model="trip.travel"
                label="Travel"
                type="number"
                prepend-icon="add_alarm"
                :loading="loading"
              ></v-text-field>
            </v-flex>
          </template>

          <!-- QTY -->
          <!-- QTY -->
          <v-flex xs12 v-if="showQty">
            <div class="body-2 grey--text text--darken-1">Quantity</div>
          </v-flex>
          <v-flex sm6 xs12 class="grey--text" v-if="showQty">
            <v-text-field
              v-model="trip.qty"
              label="Quantity"
              type="number"
              prepend-icon="chevron_right"
              :loading="loading"
            ></v-text-field>
          </v-flex>

          <!-- OPTIONS -->
          <!-- OPTIONS -->
          <v-flex sm6 xs6 class="grey--text">
            <v-autocomplete
              :color="$store.state.global.pages.docket.color"
              v-model="rateType"
              label="Rate Type"
              :items="rateTypes"
              :prepend-icon="$store.state.global.pages.rate.icon"
            ></v-autocomplete>
          </v-flex>

          <!-- WEIGHT -->
          <!-- WEIGHT -->
          <template v-if="showWeight">
            <v-flex xs12>
              <div class="body-2 grey--text text--darken-1">Mass Declaration</div>
            </v-flex>
            <v-flex xs4 class="flex-container-space-between">
              <v-text-field
                prepend-icon="shopping_basket"
                v-model.number="trip.siteWeight"
                label="Tip / Weighbridge Weight"
                type="number"
                :rules="siteWeightRules"
                :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="flex-container-space-between">
              <v-text-field
                v-model.number="trip.tipWeight"
                label="Site / Load Rite Weight"
                type="number"
                :rules="tipWeightRules"
                :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="flex-container-space-between">
              <v-text-field
                v-model.number="trip.scaleWeight"
                label="Truck / Scale Weight"
                type="number"
                :rules="scaleWeightRules"
                :loading="loading"
              ></v-text-field>
            </v-flex>
          </template>

          <!-- W/B DOCKET # -->
          <v-flex xs12 sm4>
            <v-text-field
              color="indigo"
              label="W/B Docket #"
              prepend-icon="note"
              v-model="trip.wbDocketNumber"
              :rules="wbDocketNumberRules"
            ></v-text-field>
          </v-flex>

          <!-- TRIP NOTES -->
          <!-- TRIP NOTES -->
          <v-flex xs12 sm8 class="flex-container-space-between">
            <v-text-field
              prepend-icon="note"
              v-model="trip.notes"
              label="Trip Notes"
              type="text"
              :rules="noteRules"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
          <v-btn :color="primaryNeutral" flat type="submit" :loading="loading">Add</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import RateService from "@/services/requests/rateService";

// MIXINS
import TripAddValidation from "@/services/validation/tripAddValidation";
import FormatDates from "@/services/mixins/formatDates";
import getTips from "@/services/mixins/getMasterFiles/getTips";
import getSpoils from "@/services/mixins/getMasterFiles/getSpoils";
import FilterTipSpoils from "@/services/mixins/filterTipSpoils";
import TripConditionalFields from "./tripConditionalFields";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";
import TimePickerWrapper from "@/components/ui/timePickerWrapper";

export default {
  mixins: [
    TripAddValidation,
    FormatDates,
    getTips,
    getSpoils,
    FilterTipSpoils,
    TripConditionalFields
  ],
  components: {
    DialogHeader,
    TimePickerWrapper
  },
  data() {
    return {
      prefix: "trip",
      rateType: null,
      rateTypes: [
        {
          text: "Standard Rate",
          value: null
        },
        {
          text: "Alternate Rate",
          value: "useAltRate"
        },
        {
          text: "Night Rate",
          value: "useNightRate"
        }
        // {
        //     text: 'Contractor Cost Override',
        //     value: 'useOverrideCost'
        // }
      ],
      trip: {
        tipId: null,
        spoilId: null,
        start: null,
        end: null,
        hours: 0,
        breaks: 0,
        travel: 0,
        qty: 0,
        useAltRate: false,
        useOverrideCost: false,
        useNightRate: false,
        siteWeight: 0,
        tipWeight: 0,
        scaleWeight: 0,
        wbDocketNumber: null,
        notes: ""
      },
      loading: false,
      units: ["TONNE", "HOUR", "DAY", "EA"]
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitAddTrip() {
      if (!this.$refs.addTripForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      if (!this.displayRate) {
        this.snack({ text: "No rate found", color: "yellow" });
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      var trip = this.trip;
      trip.tip = this.tipObj;
      trip.spoil = this.spoilObj;
      trip.hours = this.billableHours;
      DocketService.addTrip({
        trip: trip,
        docket: this.docket
      })
        .then(result => {
          this.fetchTrips = true;
          //this.$store.commit("trips/addToArrayState", {prop: 'trips', value: result.data.result})
          this.resetForm();
          this.snack({ text: "Trip was added!", color: "green" });
          this.loading = false;
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    },
    getTimeAsDate(time) {
      return new Date("2000-01-01" + " " + time);
    },
    resetForm() {
      this.trip = {
        tipId: null,
        spoilId: null,
        start: null,
        end: null,
        hours: 0,
        breaks: 0,
        travel: 0,
        qty: 0,
        useAltRate: false,
        useOverrideCost: false,
        useNightRate: false,
        siteWeight: 0,
        tipWeight: 0,
        scaleWeight: 0,
        wbDocketNumber: null,
        notes: ""
      };
    }
  },
  computed: {
    fetchTrips: Store.getSet({ store: "trips", prop: "fetchTrips" }),
    billableHours() {
      if (!!this.trip.start && !!this.trip.end) {
        var start = this.getTimeAsDate(this.trip.start);
        var end = this.getTimeAsDate(this.trip.end);
        if (end < start) {
          end.setDate(end.getDate() + 1);
        }
        var hours = (end - start) / 1000 / 60 / 60;
        return (
          hours -
          Number(this.trip.breaks) +
          Number(this.trip.travel)
        ).toFixed(2);
      } else {
        return 0;
      }
    },
    tipObj() {
      if (!!this.trip.tipId) {
        return this.getObjByPrimaryId(this.trip.tipId, this.tips);
      } else {
        return null;
      }
    },
    spoilObj() {
      if (!!this.trip.spoilId) {
        return this.getObjByPrimaryId(this.trip.spoilId, this.spoils);
      } else {
        return null;
      }
    }
  },
  asyncComputed: {
    displayRate() {
      if (
        !this.docket.site.id ||
        !this.docket.vehicle.id ||
        !this.trip.tipId ||
        !this.trip.spoilId
      ) {
        return null;
      }
      var params = {
        siteId: this.docket.site.id,
        vehicleId: this.docket.vehicle.id,
        tipId: this.trip.tipId,
        spoilId: this.trip.spoilId
      };
      return RateService.getRateByParams(params)
        .then(result => {
          if (!result.data.result.id) {
            this.snack({ text: "Pricing not found!", color: "yellow" });
            return null;
          } else {
            this.snack({ text: "Retreived Rate", color: "green" });
            return result.data.result;
          }
        })
        .catch(err => {
          this.snack({ text: err.repsonse.data.message, color: "red" });
          return null;
        });
    }
  },
  props: {
    docket: Object
  },
  watch: {
    rateType(val) {
      this.trip.useAltRate = false;
      this.trip.useOverrideCost = false;
      this.trip.useNightRate = false;
      if (!!val) {
        this.trip[val] = true;
      }
    }
  }
};
</script>

<style>
</style>
